import styled from 'styled-components';

import { FONT_WEIGHT, Heading } from '@makemydeal/dr-ui-bricks-components';
import type { HeadingLevel } from '@makemydeal/dr-ui-bricks-types';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import { RESPONSIVE_HEADING_SIZES } from '../../typography/responsiveHeadingSizes';

/**
 * ResponsiveHeading
 *
 * Styled extension of the shared `Heading` primitive.
 * All typographic values (font-size, font-weight, line-height) are driven
 * entirely by `RESPONSIVE_HEADING_SIZES` from the sales-checkin-components
 * constants — which itself derives every value from the ui-bricks typography
 * scale so there are no hardcoded values anywhere.
 *
 * The `level` prop is read at runtime so the correct row of the scale is
 * applied regardless of which level is passed by the consumer:
 *   • Desktop  (default)   →  RESPONSIVE_HEADING_SIZES[level].desktop
 *   • Tablet   ≤ 1279px    →  RESPONSIVE_HEADING_SIZES[level].tablet
 *   • Mobile   ≤ 767px     →  RESPONSIVE_HEADING_SIZES[level].mobile
 *
 *    A `weight` passed by the consumer wins over the scale's weight.
 */
export const ResponsiveHeading = styled(Heading)`
    @media (max-width: ${BreakPoints.TABLET}) {
        font-size: ${({ level = 2 as HeadingLevel }) => RESPONSIVE_HEADING_SIZES[level].tablet.fontSize};
        font-weight: ${({ level = 2 as HeadingLevel, weight }) =>
            weight ? FONT_WEIGHT[weight] : RESPONSIVE_HEADING_SIZES[level].tablet.fontWeight};
        line-height: ${({ level = 2 as HeadingLevel }) => RESPONSIVE_HEADING_SIZES[level].tablet.lineHeight};
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        font-size: ${({ level = 2 as HeadingLevel }) => RESPONSIVE_HEADING_SIZES[level].mobile.fontSize};
        font-weight: ${({ level = 2 as HeadingLevel, weight }) =>
            weight ? FONT_WEIGHT[weight] : RESPONSIVE_HEADING_SIZES[level].mobile.fontWeight};
        line-height: ${({ level = 2 as HeadingLevel }) => RESPONSIVE_HEADING_SIZES[level].mobile.lineHeight};
    }
`;
